import { apiGet, apiPatch, apiPost } from '@/api/http';

import type { UnreadNotificationsCountResponse } from '@/types/dashboard';
import type { NotificationSettings } from '@/types/user';
import type { CursorListingApiPayload } from '@/UI/filteredListing';

const api_url = import.meta.env.VITE_API_URL;

export type NotificationListItem = {
  id: string;
  text: string;
  created_at: string;
  is_read: boolean;
  [key: string]: unknown;
};

export const getUnreadNotificationsCount = () =>
  apiGet<UnreadNotificationsCountResponse>(
    `${api_url}notifications/unread/count/`,
  );

export const getNotificationList = (next?: string) =>
  apiGet<CursorListingApiPayload<NotificationListItem>>(
    `${api_url}notifications/${next ? '?' + next : ''}`,
  );

export const markAllNotificationsRead = () =>
  apiPost(`${api_url}notifications/mark-all-as-read/`);

export const markNotificationAsRead = (id: string) =>
  apiPost(`${api_url}notifications/${id}/mark-as-read/`);

export const getNotificationSettingList = () =>
  apiGet<NotificationSettings>(`${api_url}notifications/settings/`);

export const updateNotificationSettingList = (data: NotificationSettings) =>
  apiPatch<NotificationSettings>(`${api_url}notifications/settings/`, data);
